import { IconBase } from "./iconBase.js";
import { jsx } from "@emotion/react/jsx-runtime";
//#region src/circle.tsx
var Circle = ({ type, ...rest }) => /* @__PURE__ */ jsx(IconBase, {
	viewBox: "0 0 24 24",
	...rest,
	children: type === "stroke" ? /* @__PURE__ */ jsx("circle", {
		cx: "12",
		cy: "12",
		r: "9.25",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinecap: "square"
	}) : /* @__PURE__ */ jsx("path", {
		d: "M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2Z",
		fill: "currentColor"
	})
});
//#endregion
export { Circle };
